import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List } from 'immutable';
import { Spacing, Text } from '@reservamos/elements';

/**
 * BankDetails component.
 * Render bank details for purchase receipts, displaying field types and values
 * retrieved from the Redux payment state. Returns null if no bank details are available.
 *
 * @returns {React.Component|null} The bank details component or null if no fields exist.
 */
const BankDetails = () => {
  const { t } = useTranslation(['purchase', 'payment']);
  const fields = useSelector(({ payment }) => {
    const bankDetails = payment.get('bankDetails');
    return (bankDetails || List()).toJS();
  });

  if (fields.length === 0) return null;
  return (
    <Spacing vertical>
      <Text size="L" weight="bold">
        {t('purchase:label.purchase_receipt')}
      </Text>
      <div className="purchase-pricing">
        <div className="section-content">
          {fields.map(({ type, value }) => (
            <Spacing key={type} justifyContent="space-between">
              <Text size="S" weight="regular">
                {t('payment:bank_field', { context: type })}
              </Text>
              <Text size="S" weight="regular">
                {value}
              </Text>
            </Spacing>
          ))}
        </div>
      </div>
    </Spacing>
  );
};

export default BankDetails;
